export const AUTHENTICATE_SUCCESS_AUTHENTICATED = 'europa.user.Authenticate.Authenticated';
export const AUTHENTICATE_FAILURE_NOT_AUTHENTICATED = 'europa.user.Authenticate.NotAuthenticated';
export const AUTHENTICATE_FAILURE_TOKEN_EXPIRED = 'europa.user.Authenticate.TokenExpired';
export const AUTHENTICATE_FAILURE_UNEXPECTED_FAILURE = 'europa.user.Authenticate.UnexpectedFailure';
export const CREATE_USER_FAILURE_EMAIL_ADDRESS_ALREADY_TAKEN =
    'europa.user.CreateUser.EmailAddressAlreadyTaken';
export const CREATE_USER_FAILURE_EMAIL_DOMAIN_NOT_AUTHORIZED =
    'europa.user.CreateUser.EmailDomainNotAuthorized';
export const CREATE_USER_FAILURE_NOT_PERMITTED = 'europa.user.CreateUser.NotPermitted';
export const CREATE_USER_FAILURE_TOO_MANY_ENABLED_USERS =
    'europa.user.CreateUser.TooManyEnabledUsers';
export const CREATE_USER_FAILURE_UNEXPECTED_FAILURE = 'europa.user.CreateUser.UnexpectedFailure';
export const CREATE_USER_SUCCESS_USER_CREATED = 'europa.user.CreateUser.UserCreated';
export const CREATE_USER_FAILURE_USERNAME_ALREADY_TAKEN =
    'europa.user.CreateUser.UsernameAlreadyTaken';
export const CREATE_USER_FAILURE_USERNAME_INVALID = 'europa.user.CreateUser.UsernameInvalid';
export const DELETE_USER_FAILURE_NOT_PERMITTED = 'europa.user.DeleteUser.NotPermitted';
export const DELETE_USER_FAILURE_UNEXPECTED_FAILURE = 'europa.user.DeleteUser.UnexpectedFailure';
export const DELETE_USER_SUCCESS_USER_DELETED = 'europa.user.DeleteUser.UserDeleted';
export const DELETE_USER_FAILURE_USER_NOT_FOUND = 'europa.user.DeleteUser.UserNotFound';
export const DISABLE_USER_FAILURE_NOT_PERMITTED = 'europa.user.DisableUser.NotPermitted';
export const DISABLE_USER_FAILURE_UNEXPECTED_FAILURE = 'europa.user.DisableUser.UnexpectedFailure';
export const DISABLE_USER_FAILURE_USER_ALREADY_DISABLED =
    'europa.user.DisableUser.UserAlreadyDisabled';
export const DISABLE_USER_FAILURE_USER_CANNOT_DISABLE_ITSELF =
    'europa.user.DisableUser.UserCannotDisableItself';
export const DISABLE_USER_SUCCESS_USER_DISABLED = 'europa.user.DisableUser.UserDisabled';
export const ENABLE_USER_FAILURE_NOT_PERMITTED = 'europa.user.EnableUser.NotPermitted';
export const ENABLE_USER_FAILURE_TOO_MANY_ENABLED_USERS =
    'europa.user.EnableUser.TooManyEnabledUsers';
export const ENABLE_USER_FAILURE_UNEXPECTED_FAILURE = 'europa.user.EnableUser.UnexpectedFailure';
export const ENABLE_USER_FAILURE_USER_ALREADY_ENABLED = 'europa.user.EnableUser.UserAlreadyEnabled';
export const ENABLE_USER_SUCCESS_USER_ENABLED = 'europa.user.EnableUser.UserEnabled';
export const LIST_USER_DETAILS_FAILURE_NOT_PERMITTED = 'europa.user.ListUserDetails.NotPermitted';
export const LIST_USER_DETAILS_FAILURE_UNEXPECTED_FAILURE =
    'europa.user.ListUserDetails.UnexpectedFailure';
export const LIST_USER_DETAILS_SUCCESS_USER_DETAILS_LIST =
    'europa.user.ListUserDetails.UserDetailsList';
export const UPDATE_USER_FAILURE_EMAIL_ADDRESS_ALREADY_TAKEN =
    'europa.user.UpdateUser.EmailAddressAlreadyTaken';
export const UPDATE_USER_FAILURE_EMAIL_DOMAIN_NOT_AUTHORIZED =
    'europa.user.UpdateUser.EmailDomainNotAuthorized';
export const UPDATE_USER_FAILURE_NOT_PERMITTED = 'europa.user.UpdateUser.NotPermitted';
export const UPDATE_USER_FAILURE_UNEXPECTED_FAILURE = 'europa.user.UpdateUser.UnexpectedFailure';
export const UPDATE_USER_FAILURE_UPDATING_OWN_GROUP_NOT_ALLOWED =
    'europa.user.UpdateUser.UpdatingOwnGroupNotAllowed';
export const UPDATE_USER_SUCCESS_USER_UPDATED = 'europa.user.UpdateUser.UserUpdated';
